import React, { Component } from 'react';
import { ButtonToolbar} from 'react-bootstrap';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/lib/ToggleButton'
import './Decode.css';
import StringIO from '../StringIO/StringIO'
import NumberIO from '../NumberIO/NumberIO'
import TimeIO from '../TimeIO/TimeIO'
import ColorIO from '../ColorIO/ColorIO'
import PrettyPrintIO from '../PrettyPrintIO/PrettyPrintIO'
import ValidateIO from '../ValidateIO/ValidateIO'

class Decode extends Component {
  constructor(props) {
    super(props);
    let tmp_state = 'string'
    if( window.location.href.indexOf("number-io.com") > -1 ) {
      document.title = "NUMBER-IO.COM";
      tmp_state = 'number';
    } else if(window.location.href.indexOf("time-io.com") > -1) {
      document.title = "TIME-IO.COM";
      tmp_state = 'time';
    } else if(window.location.href.indexOf("validate-io.com") > -1) {
      document.title = "VALIDATE-IO.COM";
      tmp_state = 'validate';
    } else if(window.location.href.indexOf("color-io.com") > -1) {
      document.title = "COLOR-IO.COM";
      tmp_state = 'color'
    } else if(window.location.href.indexOf("prettyprint-io.com") > -1) {
      document.title = "PRETTYPRINT-IO.COM";
      tmp_state = 'prettyprint'
    }
    this.state = {
      type: tmp_state
    };
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  handleTypeChange(event) {
    this.setState({type: event});
  }

  render() {
    let tmp_component = ''

    switch (this.state.type) {
      case 'string':
        tmp_component = <StringIO></StringIO>;
        break;
      case 'number':
        tmp_component = <NumberIO></NumberIO>
        break;
      case 'time':
        tmp_component = <TimeIO></TimeIO>
        break;
      case 'validate':
        tmp_component = <ValidateIO></ValidateIO>
        break;
      case 'color':
        tmp_component = <ColorIO></ColorIO>
        break;
      case 'prettyprint':
        tmp_component = <PrettyPrintIO></PrettyPrintIO>
        break;
      default:
        tmp_component = <TimeIO></TimeIO>
    }

    return (
      <div>
        {this.props.children}
        <ButtonToolbar className="top-buffer">
          <ToggleButtonGroup onChange={this.handleTypeChange} type="radio" name="type" defaultValue={this.state.type}>
            <ToggleButton value={'string'}>String</ToggleButton>
            <ToggleButton value={'number'}>Number</ToggleButton>
            <ToggleButton value={'time'}>Time</ToggleButton>
            <ToggleButton value={'color'}>Color</ToggleButton>
            <ToggleButton value={'prettyprint'}>Pretty Print</ToggleButton>
            <ToggleButton value={'validate'}>Validate</ToggleButton>
          </ToggleButtonGroup>
        </ButtonToolbar>

        {tmp_component}

      </div>
    );
  }
}

export default Decode;



// WEBPACK FOOTER //
// ./src/components/Decode/Decode.js